import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { CustomLabel } from "./CustomTypography";

const StyledCard = styled(Card)(() => ({
  width: "100%",
  height: "100%",
  cursor: "pointer",
  border: "1px solid #A5A5A5",
  marginTop: "15px",
  position: "relative",
  backgroundColor: "#FFFFFF",
  "&:hover": {
    boxShadow: "0px 0px 10px 2px rgba(0,0,0,0.1)",
  },
  "&.disabled": {
    backgroundColor: "#E5E5E5",
    pointerEvents: "none",
    border: "1px solid #A5A5A5",
  },
}));

const StatusText = styled(Typography)(() => ({
  position: "absolute",
  top: "-12px",
  left: "10px",
  backgroundColor: "#fff",
  color: "green",
  padding: "2px 8px",
  borderRadius: "4px",
  fontSize: "12px",
  zIndex: 1,
}));

const CustomCardStatus = ({ title, subtitle, onClick, status }) => {
  const cardClasses = "";

  return (
    <div style={{ position: "relative", marginTop: "20px" }}>
      {<StatusText>{status}</StatusText>}
      <StyledCard onClick={onClick} className={cardClasses}>
        <CardContent
          style={{
            padding: "12px",
            marginTop: "0",
          }}
        >
          <CustomLabel>{title}</CustomLabel>
          {subtitle && (
            <Grid container spacing={1}>
              <Grid item>
                <Typography sx={{ fontSize: "13px" }}>{subtitle}</Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </StyledCard>
    </div>
  );
};

export default CustomCardStatus;
